import iconArrowRight from '@/core/assets/images/icons/arrow-right-results.svg';

const SectionResultsShowMore = ({ props, parent, listeners }) => {
    const { disabled, category, configuration } = props;
    const { hits, name, id } = category;
    const { $t } = parent;

    const isVertical = configuration.layout.templateOffer === 'grid';

    const buttonAttrs = {
        class: `l-ss-c-results-offers-show-more-button ${isVertical ? 'l-ss-c-results-offers-show-more-button-vertical' : ''}`,
        disabled: disabled,
    };

    const arrowRight = configuration.customSvgIconRightArrow ?
        configuration.customSvgIconRightArrow :
        iconArrowRight;

    return (
        <button
            {...{ ...buttonAttrs }}
            onClick={listeners.click}>

            <span class="l-ss-c-count-tag l-ss-c-results-offers-show-more-count">
                {hits}
            </span>

            <span
                class="l-ss-c-results-offers-show-more-label"
                title={`${$t('results.seeIn')} «${name || id}»`}>
                {$t('results.seeIn')} «{name || id}»
            </span>

            <i
                class="l-ss-c-results-offers-show-more-icon l-ss-c-icon"
                domPropsInnerHTML={arrowRight}></i>
        </button>
    );
};

SectionResultsShowMore.props = {
    disabled: {
        type: Boolean,
        default: false,
    },
    category: {
        type: Object,
    },
    configuration: {
        type: Object,
    },
};

export default SectionResultsShowMore;
